import { createStyles } from "@mantine/core";
import { ICustomCardProps } from "./types";
import objectPath from "object-path";
import { DisabledMixin } from "@common/constants/theme-mantine/utils";

export const useStyles = createStyles(
  (
    theme,
    {
      borderColor,
      withShadow,
      disabled,
    }: Pick<ICustomCardProps, "borderColor" | "withShadow" | "disabled">,
  ) => ({
    root: {
      borderColor:
        objectPath.get(theme, `colors.${borderColor}`) || borderColor,
      ...DisabledMixin(disabled),
      ...(withShadow
        ? { boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)" }
        : {}),
    },
  }),
);
